import { create } from "zustand";
import { UUID } from "../utils/typeDefinitions";

export interface SelectionState {
    selectedSceneObjectUuids: UUID[];
    setSelection: (uuids: UUID[]) => void;
}

export const useSelectionStore = create<SelectionState>()(
    (set) => ({
        selectedSceneObjectUuids: [],

        setSelection: (uuids: UUID[]) => set({ selectedSceneObjectUuids: uuids }),
    })
);
